import $ from 'jquery';

const replaceQueryString = (url, {
	DLRCD,
	BRNHCD,
	SECTCD,
	BRAND,
	USERID,
	USERNM,
	EMAILADDR,
}) =>
	url
		.replace(/varDLRCD/g, DLRCD)
		.replace(/varBRNHCD/g, BRNHCD)
		.replace(/varSECTCD/g, SECTCD)
		.replace(/varBRAND/g, BRAND)
		.replace(/varUSERID/g, USERID)
		.replace(/varUSERNM/g, USERNM)
		.replace(/varEMAILADDR/g, EMAILADDR)
		.replace(/txtLICSNO/g, $('input[name="LICSNO"]').val())
		.replace(/apiDLRCD/g, $('#api-DLRCD').val())
		.replace(/apiTBRNHCD/g, $('#api-BRNHCD').val())
		.replace(/apiLBRNHCD/g, $('#api-BRNHCD').val())
		.replace(/apiTSABRNH/g, $('#api-BRNHCD').val())
		.replace(/apiLSABRNH/g, $('#api-BRNHCD').val())
		.replace(/apiWORKNO/g, $('#api-WORKNO').val());

export default replaceQueryString;



// WEBPACK FOOTER //
// ./src/js/index/replaceQueryString.js